import React from 'react';
import styles from './OpsTasksPrintTable.module.scss';
import { OpsTask } from 'model/OpsTask';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/pro-regular-svg-icons';
import OpsTasksPrintRow from '../OpsTasksPrintRow/OpsTasksPrintRow';

export interface OpsTasksPrintLocationGroup {
    locationName: string;
    tasks: OpsTask[];
}

interface OpsTasksPrintTableProps {
    groups: OpsTasksPrintLocationGroup[];
}

const ColumnHeaders: React.FC = () => (
    <tr className={styles.colHeaderRow}>
        <th className={styles.colDateTime}>Date &amp; Time</th>
        <th className={styles.colTask}>Task</th>
        <th className={styles.colRoom}>Room</th>
        <th className={styles.colStaff}>Staff</th>
        <th className={styles.colCheck} />
    </tr>
);

export const OpsTasksPrintTable: React.FC<OpsTasksPrintTableProps> = ({ groups }) => {
    return (
        <table className={styles.table}>
            <tbody>
                {groups.map(group => (
                    <React.Fragment key={group.locationName}>
                        <tr className={styles.locationRow}>
                            <td
                                className={styles.locationCell}
                                colSpan={5}
                            >
                                <FontAwesomeIcon
                                    icon={faLocationDot}
                                    className={styles.locationIcon}
                                />
                                <span className={styles.locationText}>{group.locationName}</span>
                            </td>
                        </tr>
                        <ColumnHeaders />
                        {group.tasks
                            .slice()
                            .sort((a, b) => a.dueAt.valueOf() - b.dueAt.valueOf())
                            .map(task => (
                                <OpsTasksPrintRow
                                    key={task.id}
                                    task={task}
                                />
                            ))}
                    </React.Fragment>
                ))}
            </tbody>
        </table>
    );
};

export default OpsTasksPrintTable;
